/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  DocumentCreateAPIDataRequest
} from '../../model/documentCreateAPIDataRequest'
import type {
  DocumentCreateResponseData
} from '../../model/documentCreateResponseData'
import type {
  DocumentListParams
} from '../../model/documentListParams'
import type {
  DocumentReadData
} from '../../model/documentReadData'
import type {
  DocumentReadDataList
} from '../../model/documentReadDataList'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get a document by id
 */
export const documentList = (
    params?: DocumentListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<DocumentReadDataList>(
      {url: `/documents/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getDocumentListQueryKey = (params?: DocumentListParams,) => {
    return [`/documents/`, ...(params ? [params]: [])] as const;
    }

    
export const getDocumentListQueryOptions = <TData = Awaited<ReturnType<typeof documentList>>, TError = unknown>(params?: DocumentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentList>>> = ({ signal }) => documentList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentList>>, TError, TData> & { queryKey: QueryKey }
}

export type DocumentListQueryResult = NonNullable<Awaited<ReturnType<typeof documentList>>>
export type DocumentListQueryError = unknown

export const useDocumentList = <TData = Awaited<ReturnType<typeof documentList>>, TError = unknown>(
 params?: DocumentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDocumentListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocumentListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof documentList>>, TError = unknown>(params?: DocumentListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof documentList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentList>>> = ({ signal }) => documentList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof documentList>>, TError, TData> & { queryKey: QueryKey }
}

export type DocumentListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof documentList>>>
export type DocumentListSuspenseQueryError = unknown

export const useDocumentListSuspense = <TData = Awaited<ReturnType<typeof documentList>>, TError = unknown>(
 params?: DocumentListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof documentList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDocumentListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getDocumentListLoader = (queryParamsOrFn?: (DocumentListParams | ((params: Params) => DocumentListParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getDocumentListQueryKey(queryParams),
            queryFn: () => documentList(queryParams),
          }).then(() => null);
        });
      /**
 * Create a document
 */
export const documentCreate = (
    documentCreateAPIDataRequest: DocumentCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<DocumentCreateResponseData>(
      {url: `/documents/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentCreateAPIDataRequest
    },
      options);
    }
  


export const getDocumentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentCreate>>, TError,{data: DocumentCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof documentCreate>>, TError,{data: DocumentCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentCreate>>, {data: DocumentCreateAPIDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  documentCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof documentCreate>>>
    export type DocumentCreateMutationBody = DocumentCreateAPIDataRequest
    export type DocumentCreateMutationError = unknown

    export const useDocumentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentCreate>>, TError,{data: DocumentCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getDocumentCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a document by id
 */
export const documentRetrieve = (
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<DocumentReadData>(
      {url: `/documents/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getDocumentRetrieveQueryKey = (id: string,) => {
    return [`/documents/${id}/`] as const;
    }

    
export const getDocumentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof documentRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentRetrieve>>> = ({ signal }) => documentRetrieve(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DocumentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof documentRetrieve>>>
export type DocumentRetrieveQueryError = unknown

export const useDocumentRetrieve = <TData = Awaited<ReturnType<typeof documentRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDocumentRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocumentRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof documentRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof documentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentRetrieve>>> = ({ signal }) => documentRetrieve(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof documentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DocumentRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof documentRetrieve>>>
export type DocumentRetrieveSuspenseQueryError = unknown

export const useDocumentRetrieveSuspense = <TData = Awaited<ReturnType<typeof documentRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof documentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDocumentRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getDocumentRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (id) {
            return appQueryClient.prefetchQuery({
              queryKey: getDocumentRetrieveQueryKey(id),
              queryFn: () => documentRetrieve(id),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Delete a document by id
 */
export const documentDestroy = (
    id: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/documents/${id}/`, method: 'DELETE'
    },
      options);
    }
  


export const getDocumentDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof documentDestroy>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  documentDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof documentDestroy>>>
    
    export type DocumentDestroyMutationError = unknown

    export const useDocumentDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getDocumentDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Set document status to successfully uploaded
 */
export const documentStatusUploadCompleteUpdate = (
    id: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/documents/${id}/status/successful-upload/`, method: 'PATCH'
    },
      options);
    }
  


export const getDocumentStatusUploadCompleteUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentStatusUploadCompleteUpdate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof documentStatusUploadCompleteUpdate>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentStatusUploadCompleteUpdate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  documentStatusUploadCompleteUpdate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentStatusUploadCompleteUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof documentStatusUploadCompleteUpdate>>>
    
    export type DocumentStatusUploadCompleteUpdateMutationError = unknown

    export const useDocumentStatusUploadCompleteUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentStatusUploadCompleteUpdate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getDocumentStatusUploadCompleteUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    